export default __webpack_public_path__ + "static/media/home-mobile-container.4f0477c9.webp";